import { render, staticRenderFns } from "./ScalesPage.vue?vue&type=template&id=48f4953c&"
import script from "./ScalesPage.vue?vue&type=script&lang=js&"
export * from "./ScalesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports